import { editorInputClassName } from "../../common/editor/editorStyles";
import { normalizeExternalUrl } from "./normalizeExternalUrl";

export default function ExternalUrlField({ value, onChange, id }) {
	return (
		<div className="flex flex-col gap-1.5">
			<input
				id={id}
				required
				dir="ltr"
				type="text"
				inputMode="url"
				autoComplete="url"
				value={value}
				onChange={(e) => onChange(e.target.value)}
				onBlur={() => {
					const next = normalizeExternalUrl(value);
					if (next && next !== value) onChange(next);
				}}
				placeholder="google.com یا https://…"
				className={editorInputClassName}
			/>
			<p className="font-Vazir-400 text-[12px] text-darkBlue/50">
				نیازی به https نیست؛ با خروج از فیلد خودکار کامل می‌شود.
			</p>
		</div>
	);
}
